import React from "react";
import { Container, Carousel } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { getEventsData } from "../../data/events";
import "./event.css";

const EventPage = () => {
  const navigate = useNavigate();
  const eventsData = getEventsData();
  const { heading, description, headerImage, events } = eventsData;
  

  return (
    <div className="event-page">
      {/* Hero section */}
      <section
        className="event-hero"
        style={{ backgroundImage: `url(${headerImage})` }}
      >
        <Container className="text-center">
          <h1 className="event-hero__title mt-5">{heading}</h1>
        </Container>
      </section>

      {/* Description */}
      <Container className="event-description">
        <p className="event-description__text">{description}</p>
      </Container>

      {/* Events with carousel */}
      <Container className="event-content">
        {events.map((event) => (
          <section key={event.id} className="event-section">
            <h2 className="event-section__title">{event.title}</h2>
            <div className="event-carousel-wrapper">
              <Carousel
                className="event-carousel"
                indicators={false}
                interval={4000}
              >
                {event.images.map((img, index) => (
                  <Carousel.Item key={index}>
                    <div
                      className="event-carousel__image-container"
                      onClick={() => navigate(`/event-gallery/${event.id}`)}
                      style={{ cursor: "pointer" }}
                    >
                      <img
                        src={img}
                        alt={`${event.title} ${index + 1}`}
                        className="event-carousel__image"
                      />
                    </div>
                  </Carousel.Item>
                ))}
              </Carousel>
            </div>
          </section>
        ))}
      </Container>
    </div>
  );
};

export default EventPage;